export default function EditNameModal({
  name,
  onNameChange,
  onCloseButtonClick,
  onSaveButtonClick,
  isLoading
}) {
  return (
    <div className="modal-overlay">
      <div className="modal profile-modal">
        <h3>Edit Name</h3>
        <div className="header-input-container">
          <label htmlFor="name">Preferred Name</label>
          <input 
            type="text"
            name="name"
            id="name"
            value={name}
            onChange={onNameChange}
            placeholder="Name"
          />
        </div>
        <div className="header-modal-buttons-row">
          <button className="button-grey" onClick={onCloseButtonClick}>Cancel</button>
          <button className={`button-blue ${isLoading ? 'loading' : ''}`} onClick={onSaveButtonClick}>
            {!isLoading && 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};
